import { useRef, useState } from 'react';
import {
  Button,
  Menu,
  Header,
  Stack,
  IconButton,
  MenuButton
} from '@efast_public/fjd-component-library';
import { useQuery } from '@tanstack/react-query';
import { RouteKey } from '../../pages/AppRoutes';
import {GovosApiRoutes, govosBaseUrl, govosClient} from '../../api/govos-api';
import { ProductResponse } from '../../api/govos.types';
import { useNavigate } from 'react-router-dom';
import { useProfile } from '../../shared/utils/auth/AuthContext';
import {getEnvironmentVar} from "../../shared/utils/getEnvironmentVar";

export function MandantHeader() {
  const navigate = useNavigate();

  const { profile, logout } = useProfile();

  const { data: productResponse } = useQuery<ProductResponse>({
    queryKey: [GovosApiRoutes.products()],
    queryFn: () => govosClient.get<ProductResponse>(`${GovosApiRoutes.products()}`).then((r) => r.data),
    enabled: !!govosBaseUrl
  });

  const [isProductsMenuOpen, setIsProductsMenuOpen] = useState(false);
  const productsAnchorRef = useRef<HTMLButtonElement>(null);
  const products = productResponse?.userInfo?.products ?? [];

  return (
    <Header
      logo={
        <>
          <Stack direction="row" spacing="s">
            {products.length > 0 && (
              <>
                <IconButton
                  ref={productsAnchorRef}
                  data-testid="products-menu-button"
                  icon="grid"
                  variant="primary-text"
                  label="Menu"
                  onClick={() => setIsProductsMenuOpen((prev) => !prev)}
                />
                <Menu
                  open={isProductsMenuOpen}
                  anchorElement={productsAnchorRef}
                  placement="bottom-left"
                  onClose={() => setIsProductsMenuOpen(false)}
                >
                  {products.map((product) => (
                    <Menu.MenuItem
                      key={product.name}
                      label={product.name}
                      icon={`product-${product.identifier}`}
                      onClick={() =>
                        window.open(
                          product.url,
                          '_blank',
                          'noopener,noreferrer'
                        )
                      }
                    />
                  ))}
                </Menu>
              </>
            )}
            <Button
              variant="primary-text"
              beforeIcon="product-efast"
              onClick={() => {
                navigate(RouteKey.HOME);
              }}
            >
              EFAST
            </Button>
          </Stack>
        </>
      }
      navigation={
        <Stack direction={"row"} spacing="xs">
          <>
            <MenuButton variant="secondary-outline" icon="settings" >
              <Menu.MenuItem
                label="Mandantverwaltung"
                icon="settings"
                closeOnSelect
                onClick={() => {
                  navigate(RouteKey.NewMandant);
                }}
              />
              {getEnvironmentVar('REACT_APP_FEATURE_TOGGLE') === 'true' && <Menu.MenuItem
                label="Nutzerverwaltung"
                icon="user-avatar"
                closeOnSelect
                onClick={() => {
                  navigate(RouteKey.User);
                }}
              />}
            </MenuButton>
          </>
          {
        profile && (
          <>
            <MenuButton type={"button"} variant={"secondary-outline"} icon={"user-avatar"} label={`${profile.name ?? '?'}`} >
              <Menu.MenuItem
                data-testid="buttonLogout"
                label={'Abmelden'}
                icon="logout"
                closeOnSelect
                onClick={logout}
              />
              {getEnvironmentVar('REACT_APP_FEATURE_TOGGLE') === 'true' && <Menu.MenuItem
                data-testid="buttonLogout"
                label={'Profil'}
                icon="user-avatar"
                closeOnSelect
                onClick={() => {
                  navigate(RouteKey.EditProfile);
                }}
              />}
            </MenuButton>
          </>
        )}
        </Stack>
      }
    />
  );
}
